import React from 'react';
import { useTranslation } from 'react-i18next';

import { greyP4, greyP5 } from '../../theme.ts';

interface ExampleContextMenuProps {
  x: number;
  y: number;
  onClose: () => void;
  itemId: number;
  onTryExample: (id: number) => void;
  isAdmin?: boolean;
  onUnsetTemplate?: (id: number) => void;
}

const ExampleContextMenu: React.FC<ExampleContextMenuProps> = ({
  x,
  y,
  onClose,
  itemId,
  onTryExample,
  isAdmin = false,
  onUnsetTemplate,
}) => {
  const { t } = useTranslation();

  const handleTry = () => {
    onTryExample(itemId);
    onClose();
  };

  const handleUnsetTemplate = () => {
    onUnsetTemplate?.(itemId);
    onClose();
  };

  return (
    <>
      <div className="fixed inset-0 z-40" onClick={onClose} />
      <div
        className="fixed z-50 rounded-lg shadow-xl py-2"
        style={{
          left: `${x}px`,
          top: `${y}px`,
          width: '200px',
          fontFamily: 'Inter, sans-serif',
          backgroundColor: greyP5,
        }}
      >
        <button
          onClick={handleTry}
          className="w-full px-5 py-2.5 text-left text-white text-xs font-medium flex items-center justify-between hover:bg-greyP4 transition-colors duration-150"
          onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = greyP4)}
          onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = 'transparent')}
        >
          <span>{t('projects.tryItOut')}</span>
        </button>
        {isAdmin && onUnsetTemplate && (
          <>
            <div className="border-t" style={{ borderColor: greyP4 }} />
            <button
              onClick={handleUnsetTemplate}
              className="w-full px-5 py-2.5 text-left text-white text-xs font-medium flex items-center justify-between hover:bg-greyP4 transition-colors duration-150"
              onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = greyP4)}
              onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = 'transparent')}
            >
              <span>{t('projects.unsetAsTemplate')}</span>
            </button>
          </>
        )}
      </div>
    </>
  );
};

export default ExampleContextMenu;
